import { STATUS_STARTED } from '@/components/pages/assessments/util';

export const getEventsAPI = ({ track, log, slug, params }) => {
  return {
    assessmentViewed: ({ assessmentId }) => {
      // once, on initial page load and when the assessment has been loaded, track & log that this assessment has been viewed
      track('Viewed assessment', { source: params.s, assessmentId, slug });
      log({
        event: 'Viewed assessment',
        via: params.s,
        message: slug,
        object_type: 'Assessment',
        object_id: assessmentId
      });
    },

    assessmentFinished: ({ assessmentId, agencyClient }) => {
      track('Finished assessment', { assessmentId });
      log({
        event: 'Finished assessment question', // [sic] - angular has "question" appended as it is here
        via: params.s,
        message: slug,
        object_type: 'Assessment',
        object_id: assessmentId,
        receiver_id: agencyClient?.id
      });
    },

    assessmentStarted: ({ assessmentId, agencyClient }) => {
      if (agencyClient) {
        track('Started assessment', { for: 'someone else', assessmentId, source: params.s, slug });
        log({
          event: 'Started assessment',
          via: params.s,
          message: slug,
          object_type: 'Assessment',
          object_id: assessmentId,
          receiver_id: agencyClient.id
        });
      } else {
        // note that in this case log() may conditionally be called later in assessmentStatusMarked()
        track('Started assessment', { for: 'self', assessmentId, source: params.s });
      }
    },

    assessmentStatusMarked: ({ assessmentId, status, agencyClient }) => {
      if (!agencyClient && status === STATUS_STARTED) {
        // TODO are we sure we want to skip this when a supporter is completing the assessment for an agency client?
        log({
          event: 'Started assessment',
          via: params.s,
          message: slug,
          object_type: 'Assessment',
          object_id: assessmentId
        });
      }
    },

    answeredQuestion: ({ assessmentId, questionId, agencyClientId }) => {
      track('Answered assessment question', { assessmentId, questionId });
      log({
        event: 'Answered assessment question',
        via: params.s,
        message: questionId,
        object_type: 'Assessment',
        object_id: assessmentId,
        receiver_id: agencyClientId
      });
    }
  };
};
